import axios from 'axios';

const state = {
  limits: null,
  loading: false,
  error: null
};

const getters = {
  limits: state => state.limits,
  planName: state => state.limits?.plan,
  trialInfo: state => state.limits?.trial,
  usage: state => state.limits?.usage,
  remaining: state => state.limits?.remaining,
  hasActivePlan: state => !!state.limits?.status && state.limits?.status !== 'none',
};

const actions = {
  async fetchLimits({ commit }) {
    try {
      commit('setLoading', true);
      const { data } = await axios.get('/users/me/limits');
      commit('setLimits', data);
    } catch (e) {
      commit('setError', e);
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setLimits(state, payload) { state.limits = payload; },
  setLoading(state, v) { state.loading = v; },
  setError(state, e) { state.error = e; }
};

export default { state, getters, actions, mutations };
